import { Form } from "antd";

export const withForm = <T extends {} = any>(Component: any) => {
  return (props: any) => {
    const [form] = Form.useForm<T>();
    return <Component {...props} form={form} />;
  };
};
